module.exports = __webpack_public_path__ + "static/media/AC04003W_02.ce5bfa1d.png";